"use client";

import { useEffect } from "react";

const STORAGE_KEY = "snapcards_tz";

export function TimezoneSync() {
  useEffect(() => {
    try {
      const detected = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (!detected) return;

      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === detected) return;

      fetch("/api/settings/profile", {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ timezone: detected }),
      }).then((res) => {
        if (res.ok) localStorage.setItem(STORAGE_KEY, detected);
      }).catch(() => {
        // Silent — timezone sync is best-effort
      });
    } catch {
      // Silent — Intl API may not be available
    }
  }, []);

  return null;
}
